import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'search', 'results', 'image', 'id', 'ein' ]

  initialize() {
    // Load Mark.js dynamically when the controller initializes
    this.loadMarkJs();

    this.searchTarget.addEventListener("keydown", (event) => {
        if(event.key === 'ArrowUp'){ this.focusPrevious(event) }
        else if(event.key === 'ArrowDown'){ this.focusNext(event) }
        else if(event.key === 'Enter'){ this.selectFocused(event) }
      }
    );
    this.searchTarget.addEventListener("keyup",
      this.debounce((event) => {
        if(event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'Enter'){
          this.reload(event)
        }
      }, 200)
    );
  }

  async loadMarkJs() {
    try {
      const { default: Mark } = await import(
        'mark.js'
      );
      this.Mark = Mark;
    } catch (error) {
      console.error('Failed to load Mark.js:', error);
    }
  }

  reload(event){
    let search = event.target.value;
    search = search.replace(/([0-9])-([0-9])/g, '$1$2');
    if(search != ''){
      if(this.ajax){
        this.ajax.abort();
        this.ajax = null;
      }
      this.ajax = this.getAjax(`https://ac.cnstrc.com/autocomplete/${search}?key=key_t3FDxwdb77757mVJ&filters[donationsEnabled]=1&num_results_nonprofits=8&num_results_users=0`);
    } else {
      this.hide();
    }
  }

  currentFocus() {
    return this.resultsTarget.querySelector('li.focused');
  }

  nextToFocus(){
    if(this.currentFocus() && this.currentFocus().previousSibling) {
      return this.currentFocus().previousSibling;
    } else {
      return this.resultsTarget.lastElementChild;
    }
  }

  previousToFocus(){
    if(this.currentFocus() && this.currentFocus().nextSibling) {
      return this.currentFocus().nextSibling;
    } else {
      return this.resultsTarget.firstElementChild;
    }
  }

  selectFocused(event){
    event.preventDefault();
    if(this.currentFocus())
      this.select(this.currentFocus())
  }

  focusPrevious(_) {
    let current = this.currentFocus();
    let next = this.nextToFocus();
    if(this.currentFocus()) {
      current.setAttribute('aria-selected', 'false')
      current.classList.remove('focused')
    }
    next.setAttribute('aria-selected', 'true')
    next.classList.add('focused')
  }

  focusNext(_) {
    let current = this.currentFocus();
    let previous = this.previousToFocus();
    if(this.currentFocus()) {
      current.setAttribute('aria-selected', 'false')
      current.classList.remove('focused')
    }
    previous.setAttribute('aria-selected', 'true')
    previous.classList.add('focused')
  }

  hide(){
    this.element.classList.add('search-closed')
    this.element.setAttribute('aria-expanded', 'false')
    this.element.classList.remove('search-open')
    this.resultsTarget.innerHTML = '';
  }

  show(){
    this.element.classList.add('search-open')
    this.element.setAttribute('aria-expanded', 'true')
    this.element.classList.remove('search-closed')
    this.resultsTarget.innerHTML = '';
    this.imageTarget.innerHTML = '';
  }

  getAjax(url, success) {
    let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
    xhr.open('GET', url);
    xhr.onreadystatechange = () => {
      if (xhr.readyState > 3){
        if(xhr.status == 200){
          this.success(xhr.responseText);
        } else if(xhr.status != 0) {
          appsignal.sendError(new Error(`Search failed with status ${xhr.status} ${url}`))
        }
      }
    }
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send();
    return xhr;
  }

  select(item) {
    this.searchTarget.value = item.dataset.name;
    this.searchTarget.dataset.name = item.dataset.name;
    this.searchTarget.dataset.id = item.dataset.id;
    this.searchTarget.dataset.ein = item.dataset.ein;

    this.searchTarget.dispatchEvent(new Event('change', { bubbles: true }))
    this.idTarget.value = item.dataset.id;
    this.einTarget.value = item.dataset.ein;
    this.einTarget.dispatchEvent(new Event('change', { bubbles: true }))

    this.imageTarget.innerHTML = '';
    let img = item.querySelector('img, svg');
    if(img){ this.imageTarget.append(img) }
    this.hide()
  }

  async success(data) {
    this.show()
    let json = JSON.parse(data);
    if(json.sections.nonprofits.length > 0){
      json.sections.nonprofits.forEach(async element => {
        // Do not list GivingMultiplier itself
        if(element.data.slug == 'GivingMultiplier' || !element.data.id || element.data.id === '')
          return

        const src = element.data.cloudinary_id ?
          `https://res.cloudinary.com/everydotorg/image/upload/c_lfill,w_48,h_48,dpr_1/c_crop,ar_48:48/q_auto,f_auto,fl_progressive/${element.data.cloudinary_id}` :
          `/default-charity-image.svg`
        const img = `<img class='w-6 h-6 mr-2' src='${src}'>`

        let name = element.value;
        let id = element.data.id
        let ein = element.data.ein;

        let wrapper = document.createElement('div');
        wrapper.innerHTML = `
          <li class='search-item' role='option' data-name="${element.value}" data-id="${id}" data-ein="${ein}">
            ${img}
            <span class='flex-1'>${name}</span>
          </li>`
        let item = wrapper.firstElementChild;
        item.addEventListener("click", (event) => this.select(event.currentTarget))
        this.resultsTarget.appendChild(item);

        // Only create Mark instance if Mark.js is loaded
        if (this.Mark) {
          const instance = new this.Mark(item);
          instance.mark(element.matched_terms, { className: 'search-highlight' });
        }
      })
    } else {
      let wrapper = document.createElement('div');
      wrapper.innerHTML = `
        <li class='text-gray-600 p-2'>
          No results found. Please use other keywords
        </li>`
      let item = wrapper.firstElementChild;
      this.resultsTarget.appendChild(item);
    }
  }

  debounce(fn, delay) {
    var timer = null;
    return function () {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }
}
